$(function () {
  var audio = null;
  var pause_obj = null;
  var openedAutoModal = false;
  var modalScrollbarCleanup = null;

  function destroyModalScrollbar() {
    if (typeof modalScrollbarCleanup === "function") {
      modalScrollbarCleanup();
      modalScrollbarCleanup = null;
    }
  }

  // body の .scrollbar と同じオーバーレイ型カスタムスクロールバー
  function initModalScrollbar(modalContent) {
    destroyModalScrollbar();
    if (!modalContent) return;

    // 既存コンテンツを内側スクロール領域へ包む
    const scrollEl = document.createElement("div");
    scrollEl.className = "modal-content__scroll";
    while (modalContent.firstChild) {
      scrollEl.appendChild(modalContent.firstChild);
    }
    modalContent.appendChild(scrollEl);

    const track = document.createElement("div");
    track.className = "modal-content__scrollbar";
    track.innerHTML = '<div class="modal-content__scrollbar-thumb"></div>';
    modalContent.appendChild(track);

    const thumb = track.querySelector(".modal-content__scrollbar-thumb");
    let dragging = false;
    let dragStartY = 0;
    let dragStartScroll = 0;

    const getMetrics = () => {
      const scrollTop = scrollEl.scrollTop;
      const viewHeight = scrollEl.clientHeight;
      const contentHeight = scrollEl.scrollHeight;
      const trackHeight = track.clientHeight;
      const maxScroll = Math.max(contentHeight - viewHeight, 0);
      const thumbHeight =
        maxScroll > 0
          ? Math.max((viewHeight / contentHeight) * trackHeight, 40)
          : trackHeight;
      const thumbTravel = Math.max(trackHeight - thumbHeight, 0);
      const thumbTop = maxScroll > 0 ? (scrollTop / maxScroll) * thumbTravel : 0;

      return { maxScroll, thumbHeight, thumbTravel, thumbTop };
    };

    const update = () => {
      const { maxScroll, thumbHeight, thumbTop } = getMetrics();

      if (maxScroll <= 0) {
        track.classList.remove("is-visible");
        return;
      }

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
      track.classList.add("is-visible");
    };

    const onPointerMove = (event) => {
      if (!dragging) return;
      const { maxScroll, thumbTravel } = getMetrics();
      if (maxScroll <= 0 || thumbTravel <= 0) return;

      const deltaY = event.clientY - dragStartY;
      const nextScroll = dragStartScroll + (deltaY / thumbTravel) * maxScroll;
      scrollEl.scrollTop = Math.min(Math.max(nextScroll, 0), maxScroll);
    };

    const stopDrag = () => {
      if (!dragging) return;
      dragging = false;
      thumb.classList.remove("is-dragging");
      document.body.style.userSelect = "";
      update();
    };

    const onThumbPointerDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
      dragging = true;
      dragStartY = event.clientY;
      dragStartScroll = scrollEl.scrollTop;
      thumb.classList.add("is-dragging");
      document.body.style.userSelect = "none";
      thumb.setPointerCapture(event.pointerId);
    };

    const onTrackPointerDown = (event) => {
      if (event.target !== track) return;
      event.stopPropagation();
      const { maxScroll, thumbHeight, thumbTravel } = getMetrics();
      if (maxScroll <= 0 || thumbTravel <= 0) return;

      const rect = track.getBoundingClientRect();
      const clickY = event.clientY - rect.top - thumbHeight / 2;
      const ratio = Math.min(Math.max(clickY / thumbTravel, 0), 1);
      scrollEl.scrollTop = ratio * maxScroll;
    };

    thumb.addEventListener("pointerdown", onThumbPointerDown);
    thumb.addEventListener("pointermove", onPointerMove);
    thumb.addEventListener("pointerup", stopDrag);
    thumb.addEventListener("pointercancel", stopDrag);
    track.addEventListener("pointerdown", onTrackPointerDown);
    scrollEl.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(update)
        : null;
    if (resizeObserver) {
      resizeObserver.observe(scrollEl);
      Array.from(scrollEl.children).forEach((child) => {
        resizeObserver.observe(child);
      });
    }

    requestAnimationFrame(update);

    modalScrollbarCleanup = () => {
      scrollEl.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      thumb.removeEventListener("pointerdown", onThumbPointerDown);
      thumb.removeEventListener("pointermove", onPointerMove);
      thumb.removeEventListener("pointerup", stopDrag);
      thumb.removeEventListener("pointercancel", stopDrag);
      track.removeEventListener("pointerdown", onTrackPointerDown);
      if (resizeObserver) resizeObserver.disconnect();

      // ラップを解除してから破棄（再オープン時の二重ラップ防止）
      while (scrollEl.firstChild) {
        modalContent.insertBefore(scrollEl.firstChild, scrollEl);
      }
      scrollEl.remove();
      track.remove();
    };
  }

  function resetTrackPlayUI() {
    $(".track-list__contents.is-playing").removeClass("is-playing");
  }

  function checkTrackSoundSources($scope) {
    const $rows = ($scope || $(document)).find(
      ".track-list__contents:not(.no-sound-source)"
    );
    $rows.each(function () {
      const $row = $(this);
      const music_url = getMusicUrl($row);
      if (!music_url || music_url.indexOf("undefined") !== -1) {
        $row.addClass("no-sound-source");
        $row.find(".play__list").remove();
        return;
      }
      $.get(music_url, function (data) {
        if (data == "error") {
          $row.addClass("no-sound-source");
          $row.find(".play__list").remove();
        }
      });
    });
  }

  function openDiscographyModalByProductId(productId) {
    if (!productId) return;
    if (!$(".discography__modal").length) return;

    const productHtml = document.getElementById(String(productId));
    if (!productHtml) return false;

    destroyModalScrollbar();
    resetTrackPlayUI();
    if (audio) {
      audio.pause();
      audio = null;
    }
    $(".discography__modal").empty();
    const productClone = $(productHtml).clone(true, true).show();
    $(".discography__modal").append(productClone);
    $(".discography__modal").fadeIn(300).attr("aria-hidden", "false").focus();
    $("body").css("overflow", "hidden");

    const modalContent = $(".discography__modal .modal-content").get(0);
    if (modalContent) {
      initModalScrollbar(modalContent);
    }

    const handle = productHtml.getAttribute("data-product-handle");
    if (handle) {
      fetchTrackListHtml(handle).done(function (html) {
        // 取得中に別の作品へ切り替わっていたら差し込まない
        if (!productClone.closest(document.documentElement).length) return;
        productClone.find(".track-list").replaceWith(html);
        checkTrackSoundSources(productClone);
      });
    }

    return true;
  }

  // Smart Filter & Search がバリエーションのメタフィールドを返さないため、
  // トラックリストは Section Rendering API で Shopify 側の Liquid から取得する
  const trackListCache = {};

  function fetchTrackListHtml(handle) {
    if (!trackListCache[handle]) {
      trackListCache[handle] = $.get(
        "/products/" +
          encodeURIComponent(handle) +
          "?section_id=discography-tracks"
      )
        .then(function (html) {
          return $("<div>").html(html).find(".track-list").first();
        })
        .fail(function () {
          delete trackListCache[handle];
        });
    }
    return trackListCache[handle].then(function ($list) {
      return $list.clone();
    });
  }

  function getProductIdFromQuery() {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get("product_id");
    } catch (e) {
      return null;
    }
  }

  function tryOpenModalFromQuery() {
    if (openedAutoModal) return;
    var productId = getProductIdFromQuery();
    if (!productId) return;
    if (openDiscographyModalByProductId(productId)) {
      openedAutoModal = true;
    }
  }

  function getMusicUrl(obj) {
    let product_code = obj.data("product_code");
    let disk_no = obj.data("disk_no");
    let music_no = obj.data("music_no");
    let music_url =
      "https://download.della.co.jp/play_sample/" +
      product_code +
      "/" +
      disk_no +
      "/" +
      music_no;
    return music_url;
  }

  // 各トラックの音源有無チェック（初期DOM用）
  checkTrackSoundSources();

  // トラック行クリックで再生 / 停止
  $(document).on(
    "click",
    ".track-list__contents:not(.no-sound-source)",
    function () {
      const $row = $(this);
      const music_url = getMusicUrl($row);

      // 再生中の行をもう一度クリック → 停止
      if ($row.hasClass("is-playing") && audio) {
        audio.pause();
        audio = null;
        $row.removeClass("is-playing");
        pause_obj = null;
        return;
      }

      if (audio != null) {
        audio.pause();
        audio.currentTime = 0;
        resetTrackPlayUI();
      }

      audio = new Audio(music_url);
      audio.load();
      audio.play();
      $row.addClass("is-playing");
      pause_obj = $row;

      audio.addEventListener("ended", function () {
        $row.removeClass("is-playing");
        if (pause_obj && pause_obj.is($row)) {
          pause_obj = null;
        }
        audio = null;
      });
    }
  );

  //試聴曲を次々と再生するための処理
  $(".playAlbum").each(function (index, element) {
    let music_url = getMusicUrl($(this));
    let $this = $(this);
    $.get(music_url, function (data) {
      if (data == "error") {
        $this.hide();
      }
    });
  });

  // playAlbum ボタンがクリックされたときの処理
  $(document).on("click", ".playAlbum", function () {
    let music_url = getMusicUrl($(this));
    let thisObj = $(this);
    if (audio != null) {
      audio.pause();
      audio.currentTime = 0;
      resetTrackPlayUI();
      $(".stop").hide();
      $(".playAlbum").show();
    }
    audio = new Audio(music_url);
    audio.addEventListener(
      "ended",
      { obj: thisObj, handleEvent: audioEnded },
      false
    );
    audio.load();
    audio.play();
    $(this).parent().find(".stop").show();
    $(this).hide();
  });

  // 曲が終了したときの処理
  async function audioEnded(e) {
    let $this = this.obj;
    // 一旦リンクを戻す
    $this.parent().find(".playAlbum").show();
    $this.parent().find(".stop").hide();
    let disk_no = $this.parent().find(".playAlbum").data("disk_no");
    let music_no = $this.parent().find(".playAlbum").data("music_no");

    // 次の曲をセット
    dataSetAlbum(
      $this.parent().find(".playAlbum"),
      disk_no,
      parseInt(music_no) + 1
    );

    let music_url = getMusicUrl($this);
    let result = await isMusic(music_url);

    // 次の曲が存在すれば再生
    if (result) {
      $this.parent().find(".playAlbum").trigger("click");
    } else {
      // 次の曲が存在しなければディスクを入れ替えて1曲目から
      dataSetAlbum(
        $this.parent().find(".playAlbum"),
        parseInt(disk_no) + 1,
        "1"
      );
      music_url = getMusicUrl($this);
      result = await isMusic(music_url);
      if (result) {
        $this.parent().find(".playAlbum").trigger("click");
      } else {
        // 全てなければデータを初期値に戻す
        dataSetAlbum($this.parent().find(".playAlbum"), "1", "1");
      }
    }
  }

  // playAlbum のデータセット
  function dataSetAlbum(obj, disk_no, music_no) {
    obj.data("disk_no", disk_no);
    obj.data("music_no", music_no);
  }

  // 視聴音源の有無確認
  function isMusic(music_url) {
    return new Promise((resolve, reject) => {
      $.get(music_url, function (data) {
        if (data == "error") {
          resolve(false);
        } else {
          resolve(true);
        }
      });
    });
  }

  // モダール
  $(document).on("click", ".discographymodal-target", function (event) {
    const productId = $(event.target)
      .closest(".discographymodal-target")
      .data("product-id");
    openDiscographyModalByProductId(productId);
  });

  // モーダルを開く前にトラックリストを取得しておき、表示の遅れを隠す
  $(document).on(
    "mouseenter touchstart",
    ".discographymodal-target",
    function () {
      const productHtml = document.getElementById(
        String($(this).data("product-id"))
      );
      const handle =
        productHtml && productHtml.getAttribute("data-product-handle");
      if (handle) fetchTrackListHtml(handle);
    }
  );

  function closeDiscographyModal() {
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
      audio = null;
    }
    resetTrackPlayUI();
    $(".stop").hide();
    $(".play, .playAlbum").show();

    destroyModalScrollbar();
    $(".discography__modal").fadeOut(300).attr("aria-hidden", "true");
    $("body").css("overflow", "");
  }

  $(document).on("click", ".discography__modal", function (event) {
    if ($(event.target).is(".discography__modal")) {
      closeDiscographyModal();
    }
  });

  $(document).on("click", ".modal-content__close", function (event) {
    event.stopPropagation();
    closeDiscographyModal();
  });

  $(document).on("click", ".modal-content", function (event) {
    event.stopPropagation();
  });

  // 自動モーダル表示（URLクエリ）
  tryOpenModalFromQuery();

  // タグ・年代が未選択（/collections/discographyでアクセス）の時、「すべて」をchecked表示
  function markDefaultAllFilters() {
    ["590384", "592990"].forEach(function (filterId) {
      var block = document.querySelector(
        '.gf-option-block[data-filter-id="' + filterId + '"]'
      );
      if (!block) return;
      if (block.querySelector('button.checked, button[aria-checked="true"]')) {
        return;
      }
      var allBtn = block.querySelector('button[data-fvalue="すべて"]');
      if (!allBtn) return;
      allBtn.classList.add("checked");
      allBtn.setAttribute("aria-checked", "true");
    });
  }

  markDefaultAllFilters();

  window.addEventListener("globoFilterRenderCompleted", function () {
    tryOpenModalFromQuery();
    markDefaultAllFilters();
  });

  // キーワードが0件だった時
  $(window).on("load", function () {
    const $grid = $(".grid.grid--uniform.grid--view-items");
    const $input = $(".gf-controls-search-input");

    const noMatchesContents = `
      <div class="no_matches-contents">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" x2="12" y1="8" y2="12"></line>
          <line x1="12" x2="12.01" y1="16" y2="16"></line>
        </svg>
        <p class="title">該当する結果が見つかりませんでした</p>
        <p class="sub-title">他のキーワードでお試しください</p>
      </div>
    `;

    function updateNoMatchesClass() {
      if ($grid.length) {
        if (
          $grid.find(".spf-col-xl-12.spf-col-lg-12.spf-col-md-12.spf-col-sm-12")
            .length
        ) {
          if (!$grid.hasClass("no_matches")) {
            $grid.addClass("no_matches");
          }

          if (!$grid.find(".no_matches-contents").length) {
            $grid.append(noMatchesContents);
          }

          $grid
            .find(".spf-col-xl-12.spf-col-lg-12.spf-col-md-12.spf-col-sm-12")
            .hide();
        } else {
          $grid.removeClass("no_matches");
          $grid.find(".no_matches-contents").remove();
          $grid
            .find(".spf-col-xl-12.spf-col-lg-12.spf-col-md-12.spf-col-sm-12")
            .show();
        }
      }
    }

    updateNoMatchesClass();

    $input.on("keyup", function () {
      updateNoMatchesClass();
    });

    const observer = new MutationObserver(updateNoMatchesClass);
    if ($grid[0]) {
      observer.observe($grid[0], { childList: true, subtree: true });
    }
  });
});
